export default __webpack_public_path__ + "static/media/brand_04.92db5257.png";